import React, { useRef, useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import AggregationCardsContainer from './AggregationCardsContainer';
import useGetIdsOnProducts from './hooks/use-get-ids-on-products';
import { GET_BRANDS } from '../../services/querys';
import { DEFUALT_SORT } from './constants';

const Brands = ({ featuredOnly, ...otherProps }) => {
  const counter = useRef(0);
  const [brands, setBrands] = useState([]);
  const { aggsLoading, where, recordIds } = useGetIdsOnProducts({
    ...otherProps,
    featuredOnly,
    relationProperty: 'brandIds'
  });

  const { loading, refetch } = useQuery(GET_BRANDS, {
    variables: {
      where: where[counter.current],
      sort: DEFUALT_SORT
    },
    skip: aggsLoading || !where.length || where.length <= counter.current,
    onCompleted: data => {
      const newBrands = [...brands, ...data.brands];
      counter.current += 1;
      setBrands(newBrands);
    }
  });

  useEffect(() => {
    if (counter.current < where.length) {
      refetch({ where: where[counter.current], sort: DEFUALT_SORT });
    }
  }, [refetch, where]);

  if (loading || !brands || !brands.length) return null;
  return <AggregationCardsContainer {...otherProps} items={brands} recordIds={recordIds} />;
};

export default Brands;
